import React from 'react';

// The pill colour follows the severity word (Urgent = red, Aspirational = amber).
const badgeVariant = (severity) => {
    const s = (severity || '').toLowerCase();
    if (s.includes('urgent')) return 'urgent';
    if (s.includes('aspirational')) return 'aspirational';
    return 'neutral';
};

// Show the severity word with only its first letter capitalised (URGENT -> Urgent).
const formatSeverity = (severity) => {
    const s = (severity || '').toLowerCase();
    return s.charAt(0).toUpperCase() + s.slice(1);
};

const CategoryTable = (props) => {
    const { contents, data } = props;
    return (
        <div className="keytakeaway-column">
            <div className="keytakeaway-column__title">{contents.title}</div>
            <div className="keytakeaway-column__head">
                <span className="keytakeaway-column__head-cell keytakeaway-column__head-cell--cat">Lever / Category</span>
                <span className="keytakeaway-column__head-cell">Behavior</span>
            </div>
            <div className="keytakeaway-column__cards">
                {data.map((item, index) => (
                    <div className="ktcard" key={item.id != null ? item.id : index}>
                        <div className={`ktcard__category ${contents.className}`}>
                            <span>{item.category}</span>
                        </div>
                        <div className="ktcard__behavior">
                            <span className="ktcard__behavior-text">{item.behavior}</span>
                            {item.severity && (
                                <span className={`ktcard__badge ktcard__badge--${badgeVariant(item.severity)}`}>
                                    {formatSeverity(item.severity)}{item.behaviorMean != null ? ` · mean ${Number(item.behaviorMean).toFixed(2)}` : ''}
                                </span>
                            )}
                        </div>
                    </div>
                ))}
            </div>
        </div>
    );
};

export default CategoryTable;
